export type ArticleNames =
  | "cms-hosting"
  | "cms-hosting-express"
  | "onlineshop"
  | "onlineshop-express";

interface RelocationArticle {
  name: ArticleNames;
  price: number;
  timeRange: {
    min: number;
    max: number;
  };
}

const cmsHosting: RelocationArticle = {
  name: "cms-hosting",
  price: 150,
  timeRange: {
    min: 5,
    max: 10,
  },
};

const cmsHostingExpress: RelocationArticle = {
  name: "cms-hosting-express",
  price: 299,
  timeRange: {
    min: 2,
    max: 3,
  },
};

const onlineshop: RelocationArticle = {
  name: "onlineshop",
  price: 250,
  timeRange: {
    min: 10,
    max: 14,
  },
};

const onlineshopExpress: RelocationArticle = {
  name: "onlineshop-express",
  price: 439,
  timeRange: {
    min: 2,
    max: 3,
  },
};

export const relocationArticles = [
  cmsHosting,
  onlineshop,
  cmsHostingExpress,
  onlineshopExpress,
];

export const additionalDataComparePrice = 50;
export const domainTransferPricePerDomain = 9;

export const getArticleByName = (name: ArticleNames): RelocationArticle => {
  return relocationArticles.find((article) => article.name === name)!;
};
